import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { ExportService } from '../shared/services/exportservice';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';

@Component({
  selector: 'app-processed-result-list',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './processed-result-list.component.html',
  styleUrl: './processed-result-list.component.scss'
})
export class ProcessedResultListComponent {
  students:any;
  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  };
  displayedColumns: string[] = [
    'actions','sno','register_no','semester_number', 'exam_month', 'exam_year',
    'raw_total_sub1', 'processed_total_sub1', 'grade_sub1', 'earned_credits_sub1','grade_points_sub1',
    'raw_total_sub2', 'processed_total_sub2', 'grade_sub2','earned_credits_sub2','grade_points_sub2',
    'raw_total_sub3', 'processed_total_sub3', 'grade_sub3','earned_credits_sub3','grade_points_sub3',
    'raw_total_sub4', 'processed_total_sub4', 'grade_sub4','earned_credits_sub4','grade_points_sub4',
    'raw_total_sub5', 'processed_total_sub5', 'grade_sub5','earned_credits_sub5','grade_points_sub5',
    'raw_total_sub6', 'processed_total_sub6', 'grade_sub6','earned_credits_sub6','grade_points_sub6',
    'raw_total_sub7', 'processed_total_sub7', 'grade_sub7','earned_credits_sub7','grade_points_sub7',
    'raw_total_sub8', 'processed_total_sub8', 'grade_sub8','earned_credits_sub8','grade_points_sub8',
    'overall_raw_total','overall_processed_total','overall_result','total_percentage','total_earned_credits',
    'weighted_grade_points','attempt_count','sgpa','cgpa'
  ];

  constructor(private http: HttpClient, private api: ApiService, private common: CommonService, private fb: FormBuilder, private exportService: ExportService) {}

  ngOnInit(){
    this.get_all_students_processed_result()
  }

  get_all_students_processed_result(courseId?: string, semesterId?: string, search?: string) {
    const userData = localStorage.getItem('user');

    const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
  
    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }
  
    const user = JSON.parse(userData);
    interface StudentFilterPayload {
      user_id: string;
      course_id?: string;
      semester_id?: string;
      search?: String;
    }
    
    const payload: StudentFilterPayload = {
      user_id: user.userId
    };
    
    if (courseId) {
      payload.course_id = courseId
    }
    if (semesterId) {
      payload.semester_id = semesterId;
    }
    if (search){
      payload.search = search
    }
  
    this.api.post(`results/processed_result_list?${queryParam.join('&')}`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/Students fetched successfully:', resp.data);
          // You can bind resp.data to a variable for displaying in a table
          this.students= resp.data;
          this.pagination.length = resp?.totalCount || 0;
          resp.data = this.students
        } else {
          console.error('Failed to fetch students:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

}
